import { render, staticRenderFns } from "./DocuformDeleteConfirmation.vue?vue&type=template&id=7dfa0d16"
import script from "./DocuformDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./DocuformDeleteConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports